import SEOPageTemplate from '../components/SEOPageTemplate';

const ChauffeurPrinceton = () => (
  <SEOPageTemplate
    city="Princeton"
    state="NJ"
    route="/chauffeur-princeton-nj"
    imageSrc="/princeton-nj-limo.jpg"
    introduction="In Princeton, New Jersey, where academic excellence meets corporate innovation, TiLimousine delivers a transportation service that understands the unique needs of this prestigious community. Our chauffeurs are intimately familiar with Princeton's distinctive character, from the historic university campus to the bustling business parks. Whether you're visiting Princeton University, attending a conference at the Institute for Advanced Study, or exploring the city's growing pharmaceutical and technology sectors, our service ensures your journey through Princeton is as distinguished as the city itself."
    testimonial={{
      quote: "As a pharmaceutical executive, I frequently host international researchers visiting our Princeton campus. TiLimousine's chauffeurs understand the importance of making a professional first impression. Their knowledge of Princeton's academic and corporate landscape has been invaluable for our business.",
      author: "Dr. Patricia K.",
      role: "VP of Research, Princeton Pharma"
    }}
    services={[
      'Luxury chauffeur service for airport transfers and FBO pickup',
      'Executive car service and black car service for business travel',
      'Hourly chauffeur hire and as-directed black car service',
      'Private driver service for events, weddings, and VIPs',
      'Long-distance city-to-city rides: Princeton ⇄ NYC, Princeton ⇄ Philadelphia',
      'Professional chauffeur company for meetings and corporate events',
      'Livery service and luxury livery transportation',
      'Town car service and car and driver rental',
      'Book a chauffeur in Princeton',
      'Best chauffeur in New Jersey',
      'Chauffeured transportation for VIPs',
      'Luxury car with driver',
      'Business travel car service',
      'Limo vs black car service Princeton',
      'Best executive car service in Princeton',
      'FBO pickup with luxury car',
      'Chauffeur for meetings and corporate events'
    ]}
    airports={[
      'Princeton Airport (PCT)',
      'Trenton-Mercer Airport (TTN)',
      'Newark Liberty International Airport (EWR)',
      'Philadelphia International Airport (PHL)',
      'Teterboro Airport (TEB)',
      'JFK',
      'LGA',
      'Atlantic City International Airport (ACY)'
    ]}
    neighborhoods={[
      'Princeton University',
      'Princeton Junction',
      'Princeton Borough',
      'Princeton Township',
      'Institute for Advanced Study',
      'Forrestal Campus',
      'Carnegie Center',
      'Princeton Forrestal Village',
      'Alexander Road',
      'Nassau Street',
      'West Windsor',
      'Greater Princeton Area'
    ]}
  />
);

export default ChauffeurPrinceton; 